import Vue from "vue";
import Portal from "./Portal.vue";
import Menus from "./Menus.vue";
import Lookup from "./Lookup.vue";
import Game from "./Game.vue";
import Organisation from "./Organisation.vue";
import User from "./User.vue";
import Integration from "./Integration.vue";
import EmailTemplate from "./EmailTemplate.vue";
import Sponsors from "./Sponsor.vue";
import InviteUser from "./InviteUser.vue";

Vue.component("portal", Portal);
Vue.component("menus", Menus);
Vue.component("lookup", Lookup);
Vue.component("game", Game);
Vue.component("organisation", Organisation);
Vue.component("user", User);
Vue.component("integration", Integration);
Vue.component("emailTemplate", EmailTemplate);
Vue.component("sponsors", Sponsors);
Vue.component("inviteUser", InviteUser);

export {};